import {
  Login,
  Dashboard,
} from "@modules/index";
import { Redirect } from "@modules/Auth/Redirect";
import { ReactNode } from "react";
import { UnAuthorized } from "@components/ErrorHandlers/UnAuthorized";
import { ModuleSelection } from "../../Components/ModuleSelection/ModuleSelection";
import { Templates } from "~/Modules/ContractManagement/Templates/Templates";
import { AddNewTemplateDocument } from "~/Modules/ContractManagement/Templates/Onboarding/AddNewTemplateDocument";
import { TemplatesDrilldown } from "~/Modules/ContractManagement/Templates/Drilldown/Overview/TemplatesDrilldown";
import { Divisions } from "~/Modules/ContractManagement/Divisions/Divisions";
import { AddNewDivision } from "~/Modules/ContractManagement/Divisions/Onboarding/AddNewDivision";
import { SPA } from "~/Modules/ContractManagement/SPA/SPA";
import { AddNewSPA } from "~/Modules/ContractManagement/SPA/SubModules/Onboarding/AddNewSPA";
import { SPADrilldown } from "~/Modules/ContractManagement/SPA/Drilldown/SPADrilldown";
import { ReviewSPA } from "~/Modules/ContractManagement/SPA/ReviewSPA";
import { Approver } from "~/Modules/ContractManagement/Approvers/Approver";
import { AddApprover } from "~/Modules/ContractManagement/Approvers/AddApprover";
import { Watchers } from "~/Modules/ContractManagement/Watchers/Watchers";
import { AddWatchers } from "~/Modules/ContractManagement/Watchers/AddWatchers";
import { UserManagement } from "~/Modules/UserManagement/SPA/SPAUserManagement";
import { LogManagement } from "~/Modules/ContractManagement/Logs/Logs";
import { NewUser } from "~/Modules/UserManagement/SPA/AddNewSPAUser";
import { Subsidiary } from "~/Modules/ContractManagement/Subsidiaries/Subsidiaries";
import { AddNewSubsidiary } from "~/Modules/ContractManagement/Subsidiaries/Onboarding/AddNewSubsidiaries";
import { AddNewOneStopCentre } from "~/Modules/ContractManagement/OneStopCentre/Onboarding/AddNewOneStop";
import { OneStopCentre } from "~/Modules/ContractManagement/OneStopCentre/OneStopCentre";
import { BudgetManager } from "~/Modules/ContractManagement/BudgetManager/BudgetManager";
import { PCDWatchers } from "~/Modules/ContractManagement/Watchers/PCDWatchers";
import { AddNewPCDWatchers } from "~/Modules/ContractManagement/Watchers/AddNewPCDWatchers";
// import { Dashboard } from "~/Modules/ContractManagement/SubModules/Dashboard/Dashboard";

interface RouteBase {
  path: string;
  element: ReactNode;
}

interface ProtectedRoutes extends RouteBase {
  roles: string[];
}

const userDataString = localStorage.getItem("user");
const userData = userDataString ? JSON.parse(userDataString) : {};
const { role = "CLM_USERS" } = userData || {};
export const protectRoutes: ProtectedRoutes[] = [
  {
    path: `/dashboard`,
    element: <Dashboard/>,
    roles: ["*"],
  },
  {
    path: `/templates`,
    element: <Templates />,
    roles: ["SPA_ADMIN","SPA_USER"],
  },
  {
    path: `/spa`,
    element: <SPA />,
    roles: ["*"],
  },
  {
    path: `/spa-review`,
    element: <ReviewSPA />,
    roles: ["SPA_ADMIN", "SPA_APPROVER"],
  },
  {
    path: `/divisions`,
    element: <Divisions />,
    roles: ["SPA_ADMIN"],
  },
  {
    path: `/subsidiaries`,
    element: <Subsidiary />,
    roles: ["SPA_ADMIN"],
  },
  {
    path: `/subsidiaries/create`,
    element: <AddNewSubsidiary />,
    roles: ["SPA_ADMIN"],
  },
  {
    path: `/subsidiaries/edit`,
    element: <AddNewSubsidiary />,
    roles: ["SPA_ADMIN"],
  },
  {
    path: `/subsidiaries/view`,
    element: <AddNewSubsidiary />,
    roles: ["SPA_ADMIN"],
  },
  {
    path: `/templates/create`,
    element: <AddNewTemplateDocument />,
    roles: ["SPA_ADMIN"],
  },
  {
    path: `/divisions/create`,
    element: <AddNewDivision />,
    roles: ["SPA_ADMIN"],
  },
  {
    path: `/divisions/edit`,
    element: <AddNewDivision />,
    roles: ["SPA_ADMIN"],
  },
  {
    path: `/divisions/view`,
    element: <AddNewDivision />,
    roles: ["SPA_ADMIN"],
  },
  {
    path: `/templates/edit/:id`,
    element: <AddNewTemplateDocument />,
    roles: ["SPA_ADMIN"],
  },
  {
    path: `/templates/view/:id`,
    element: <TemplatesDrilldown />,
    roles: ["SPA_ADMIN","USER"],
  },
  {
    path: `/spa/add`,
    element: <AddNewSPA />,
    roles: ["*"],
  },
  {
    path: `/spa/edit/`,
    element: <AddNewSPA />,
    roles: ["*"],
  },
  {
    path: `/spa/view/:id`,
    element: <SPADrilldown />,
    roles: ["*"],
  },
  {
    path: `/spa-review/view/:id`,
    element: <SPADrilldown />,
    roles: ["SPA_ADMIN", "SPA_APPROVER"],
  },
  {
    path: `/spa-watcher/view/:id`,
    element: <SPADrilldown />,
    roles: ["*"],
  },
  {
    path: `/spa-watcher`,
    element: <SPA />,
    roles: ["*"],
  },
  {
    path: `/approver`,
    element: <Approver />,
    roles: ["SPA_ADMIN"],
  },
  {
    path: `/approver/add/`,
    element: <AddApprover />,
    roles: ["SPA_ADMIN"],
  },
  {
    path: `/approver/edit/`,
    element: <AddApprover />,
    roles: ["SPA_ADMIN"],
  },
  {
    path: `/approver/view/`,
    element: <AddApprover />,
    roles: ["SPA_ADMIN"],
  },
  {
    path: `/watchers`,
    element: <Watchers />,
    roles: ["SPA_ADMIN"],
  },
  {
    path: `/watchers/add`,
    element: <AddWatchers />,
    roles: ["SPA_ADMIN"],
  },
  {
    path: `/watchers/edit`,
    element: <AddWatchers />,
    roles: ["SPA_ADMIN"],
  },
  {
    path: `/watchers/view`,
    element: <AddWatchers />,
    roles: ["SPA_ADMIN"],
  },
  {
    path: `/one-stop-centre`,
    element: <OneStopCentre />,
    roles: ["SPA_ADMIN"],
  },
  {
    path: `/one-stop-centre/edit`,
    element: <AddNewOneStopCentre />,
    roles: ["SPA_ADMIN"],
  },
  {
    path: `/one-stop-centre/view`,
    element: <AddNewOneStopCentre />,
    roles: ["SPA_ADMIN"],
  },
  {
    path: `/one-stop-centre/create`,
    element: <AddNewOneStopCentre />,
    roles: ["SPA_ADMIN"],
  },
    {
    path: `/pcd-watchers`,
    element: <PCDWatchers />,
    roles: ["SPA_ADMIN"],
  },
  {
    path: `/pcd-watchers/edit`,
    element: <AddNewPCDWatchers />,
    roles: ["SPA_ADMIN"],
  },
    {
    path: `/pcd-watchers/view`,
    element: <AddNewPCDWatchers />,
    roles: ["SPA_ADMIN"],
  },
    {
    path: `/pcd-watchers/create`,
    element: <AddNewPCDWatchers />,
    roles: ["SPA_ADMIN"],
  },
  {
    path: `/user-management/add`,
    element: <NewUser />,
    roles: ["SPA_ADMIN"],
  },
  {
    path: `/user-management`,
    element: <UserManagement />,
    roles: ["SPA_ADMIN"],
  },
  {
    path: `/logs`,
    element: <LogManagement />,
    roles: ["SPA_ADMIN"],
  },
  {
    path: `/budget-manager`,
    element: <BudgetManager />,
    roles: ["SPA_ADMIN"],
  }
];

export const globalRoutes = [
  {
    path: "/module-selection",
    element: <ModuleSelection />,
  },
  {
    path: "/auth/login",
    element: <Login />,
  },
  {
    path: "/authorize/redirect",
    element: <Redirect />,
  },
  {
    path: "/unauthorized-entry",
    element: <UnAuthorized />,
  },
];
